import { axios, HOST, config } from "./settiing";

export default {
  /** Voucher api **/
  getVoucherList() {
    return axios.get(`${HOST}/resource/web/voucher`, config);
  },
  getVoucherListForApprovement() {
    return axios.get(`${HOST}/resource/voucher`, config);
  },
  addVoucher(data) {
    return axios.post(`${HOST}/resource/voucher`, data, config);
  },
  updateVoucher(data) {
    return axios.put(`${HOST}/resource/voucher`, data, config);
  },
  deleteVoucher(voucherId) {
    return axios.delete(`${HOST}/resource/voucher/${voucherId}`, config);
  },

  /** VoucherState api **/
  getVoucherStateListBetween(start, end, params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(
      `${HOST}/resource/web/voucher-state/${start}/${end}?${query}`,
      config
    );
  },
  BackVoucherState(data) {
    return axios.put(`${HOST}/resource/voucherState`, data, config);
  },
  getVoucherStateInfoById(id) {
    return axios.get(`${HOST}/resource/voucherState/${id}`, config);
  },
  updateVoucherStateExpirationDateById(data) {
    return axios.put(`${HOST}/resource/voucherState/`, data, config);
  },
  getGroupVoucherState(customerId) {
    return axios.get(
      `${HOST}/resource/voucherState/groupCustomer/${customerId}`,
      config
    );
  },
  getCustomerVoucher(customerId) {
    return axios.get(
      `${HOST}/resource/voucherState/byCustomer/${customerId}`,
      config
    );
  },

  /** VoucherLog api **/
  getvoucherLogInfoByVoucherStateId(id) {
    return axios.get(`${HOST}/resource/voucherLog/${id}`, config);
  },
};
